import { Props } from './types';
import './style.css';

/**
 * @deprecated Do not use this component. Use the base components at the root of the UI folder instead.
 */
const BlockQuote = ({ title, quote, name }: Props) => {
  return (
    <blockquote className="quote dark:bg-uniform-blue-700 light:bg-uniform-blue-700 rounded-lg py-4 px-8 text-center font-roboto">
      {title && (
        <p className="dark:text-uniform-blue-200 light:text-uniform-blue-200 text-xs uppercase mb-2">
          {title}
        </p>
      )}

      <p className="dark:text-uniform-white-base light:text-uniform-white-base font-medium text-lg mb-2 tracking-tightest">
        &quot;{quote}&quot;
      </p>

      <cite className="dark:text-uniform-blue-200 light:text-uniform-blue-200 font-bold text-sm uppercase not-italic tracking-tightest">
        - {name}
      </cite>
    </blockquote>
  );
};

export default BlockQuote;
